-<!--公用组件：loading
-      /**
-      * @desc 组件描述
-      * @param {Boolean} [maskVisible] - 是否显示遮罩
-      * @example 调用示例
-      *this.$loading.show(false)
-      *this.$loading.hide()
-      */
--->
<template>
  <div class="loading" v-if="visible">
     <div class="loading-mask" v-if="maskVisible"></div>
     <i class="icon-font icon-loading"></i>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        visible: false,
        maskVisible: true
      };
    }
  };
</script>
<style src="../../static/iconfont/iconfont.css"></style>
<style lang="scss">
@keyframes rotating {
 0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(1turn);
  }
 }

.icon-loading:before {
  content: "\e861";
}

.loading{
    width: 100%;
    height:  100%;;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999;
    .icon-loading{
      position: fixed;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      font-size: px2vh(80px);
      margin-left: -5vh;
      margin-top: -6vh;
      z-index: 1000;
    }
}

.loading-mask{
  width: 100%;
  height: 100%;
  top: 0;
  bottom: 0;
  left: 0;
  top: 0;
  position: fixed;
  background-color: #000;
  opacity: 0.7;
}
</style>


// WEBPACK FOOTER //
// src/components/common-components/features/loading/index.vue